import React,{useState} from 'react'
import {
    Box,
    InputGroup,
    InputRightElement,
    Input
  } from "@chakra-ui/react";

import { BsSearch } from "react-icons/bs";


function CommentSearch(props) {
    const [search,setSearch] = useState('');

    const handleSubmit=()=>{
        if(props.hasOwnProperty('onSearch'))
            props.onSearch(search);
    }
    const restSearch= ()=>{
        if(props.hasOwnProperty('onSearch'))
            props.onSearch('');
    }
    return (
        <Box w={60} p={2} pr={4}>
        <InputGroup size="md">
          <Input
            pr="4.5rem"
            placeholder="Comment search"
            size="md"
            onChange={(event) => {
              if(event.currentTarget.value === ''){ 
                restSearch();
              } 
              return setSearch(event.currentTarget.value)
            }}
            onKeyUp={(event)=>{
              if(event.keyCode === 13){ 
                handleSubmit(); 
              }
              return;
            }} 
          />
          <InputRightElement style={{'cursor': 'pointer'}} borderRadius={'0px 5px 5px 0px'} width="4.5rem" onClick={handleSubmit} background={'#E2E8F0'}>
            <BsSearch  />
          </InputRightElement>
        </InputGroup>
      </Box>
    )
}

export default CommentSearch
